import { render, staticRenderFns } from "./ElProgressBarV2.vue?vue&type=template&id=48c33ba4"
import script from "./ElProgressBarV2.vue?vue&type=script&lang=js"
export * from "./ElProgressBarV2.vue?vue&type=script&lang=js"
import style0 from "./ElProgressBarV2.vue?vue&type=style&index=0&id=48c33ba4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports